import styled from 'styled-components';

export const StyledContainer = styled.div`
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  color: #313131;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;

  min-width: 300px;
  width: fit-content;
  position: relative;
`;
